interface FormatEUROptions {
  locale?: string;
  decimals?: number;
  showSymbol?: boolean;
}

export const formatEUR = (amount: number, options: FormatEUROptions = {}): string => {
  const { locale = 'es-ES', decimals = 2, showSymbol = true } = options;

  const formatter = new Intl.NumberFormat(locale, {
    style: showSymbol ? 'currency' : 'decimal',
    currency: 'EUR',
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });

  return formatter.format(amount);
};
